import { gql } from '@apollo/client'

export const INDEED_TRACKING_LINK_STATUS = gql`
  query IndeedTrackingLinkStatus($trackingLinkId: String!) {
    indeedTrackingLinkStatus(trackingLinkId: $trackingLinkId) {
      statusReason
      summaryLabel
      summaryIcon
      description
      details {
        label
        icon
      }
      lifecycleStatus
      viewUrl
      imageUrl
      imageAltText
    }
  }
`

export const SYNC_JOB_TO_INDEED = gql`
  mutation SyncJobToIndeed(
    $trackingLinkId: String!
    $jobSourceConnectionId: String
  ) {
    syncJobToIndeed(
      trackingLinkId: $trackingLinkId
      jobSourceConnectionId: $jobSourceConnectionId
    ) {
      trackingLinkId
      externalPostingId
      jobSourceConnectionId
    }
  }
`

export const EXPIRE_JOB_ON_INDEED = gql`
  mutation ExpireJobOnIndeed($trackingLinkId: String!) {
    expireJobOnIndeed(trackingLinkId: $trackingLinkId) {
      trackingLinkId
      externalPostingId
      jobSourceConnectionId
    }
  }
`
